import { Link } from "react-router-dom";
import { HeartOff, ArrowLeft } from "lucide-react";
import { useStore } from "../context/StoreContext";
import { getProductById } from "../data/products";
import ProductCard from "../components/ProductCard";

const Wishlist = () => {
  const { wishlist } = useStore();
  const items = wishlist.map(getProductById).filter(Boolean);

  return (
    <div className="mx-auto max-w-6xl px-4 sm:px-6 py-6 sm:py-8" data-testid="wishlist-page">
      <Link
        to="/shop"
        className="btn-3d btn-sm btn-ghost mb-4"
        data-testid="wishlist-back-btn"
      >
        <ArrowLeft size={18} strokeWidth={3} /> Back
      </Link>
      <h1 className="font-display text-3xl sm:text-4xl mb-5">
        <span className="wiggle inline-block mr-2">💖</span>Your wishlist
      </h1>

      {items.length === 0 ? (
        <div className="chunky-card p-10 text-center" data-testid="wishlist-empty">
          <div className="text-7xl mb-4 bob">💭</div>
          <h2 className="font-display text-2xl mb-2">No favorites yet</h2>
          <p className="mb-5 text-lg" style={{ color: "#484848" }}>
            Tap the heart on any product to save it here.
          </p>
          <Link to="/shop" className="btn-3d btn-pink" data-testid="wishlist-shop-btn">
            <HeartOff size={20} strokeWidth={3} />
            Find things you love
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
          {items.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      )}
    </div>
  );
};

export default Wishlist;
